import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Form, Input } from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;

  const {
    password, confirm_password, first_name, last_name, email, is_tenancy_active, is_ad_user
  } = dataSource;

  return {
    email: Form.createFormField({ value: email }),
    password: Form.createFormField({ value: password }),
    confirm_password: Form.createFormField({ value: confirm_password }),
    is_tenancy_active: Form.createFormField({ value: is_tenancy_active }),
    is_ad_user: Form.createFormField({ value: is_ad_user }),
    first_name: Form.createFormField({ value: first_name }),
    last_name: Form.createFormField({ value: last_name })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, checkboxFormItemLayout, inputFormItemLayout, form
}) => {
  const [confirmPasswordDirty, confirmPasswordBlur] = useState(false);

  const validatePassword = (rule, value, callback) => {
    if (value && confirmPasswordDirty) {
      form.validateFields(['confirmPassword'], { force: true });
    }
    callback();
  };

  const validatePasswordMatch = async (rule, value, callback) => {
    if (await value && value !== form.getFieldValue('password')) {
      callback('Confirmation password does not match.');
    }
    callback();
  };

  const handleConfirmPasswordBlur = (e) => {
    const { value } = e.target;
    confirmPasswordBlur(confirmPasswordDirty || !!value);
  };

  const { getFieldDecorator } = form;
  const {
    id, first_name, last_name, email, is_tenancy_active, is_ad_user
  } = dataSource;
  const passwordRequired = id == null || id === -1;
  const readonly = !canAdmin || is_ad_user;
  return (
    <>
      {is_ad_user && (
        <div className="bhp-ad-user">
          <span className="fa-stack">
            <i className="fas fa-circle fa-stack-1x" />
            <i className="fas fa-info fa-stack-1x" />
          </span>
          To update the account details for this user, please apply changes in Active Directory.
        </div>
      )}
      <Form>
        <FormItem {...inputFormItemLayout} label="Username">
          {getFieldDecorator('email', {
            initialValue: email,
            rules: [
              {
                required: true,
                message: 'Please enter a Username.'
              },
              {
                type: 'email',
                message: 'Username must be a valid E-mail.'
              }
            ]
          })(<Input placeholder="joe.bloggs@bhp.com" disabled={readonly} />)}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Password">
          {getFieldDecorator('password', {
            rules: [
              {
                required: passwordRequired,
                message: 'Please enter Password.'
              },
              { validator: validatePassword }
            ]
          })(<Input type="password" disabled={readonly} autoComplete="off" />)}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Confirm Password">
          {getFieldDecorator('confirm_password', {
            rules: [
              {
                required: passwordRequired,
                message: 'Please confirm Password!'
              },
              { validator: validatePasswordMatch }
            ]
          })(<Input type="password" disabled={readonly} autoComplete="off" onBlur={handleConfirmPasswordBlur} />)}
        </FormItem>
        <FormItem {...checkboxFormItemLayout}>
          {getFieldDecorator('is_tenancy_active', {
            initialValue: is_tenancy_active,
            valuePropName: 'checked'
          })(<Checkbox disabled={readonly}>Active</Checkbox>)}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="First Name">
          {getFieldDecorator('first_name', {
            initialValue: first_name,
            rules: [
              {
                required: true,
                message: 'Please enter user\'s First Name.'
              },
              {
                whitespace: true,
                message: 'Please enter user\'s First Name.'
              }
            ]
          })(<Input placeholder="Joe" disabled={readonly} />)}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Last Name">
          {getFieldDecorator('last_name', {
            initialValue: last_name,
            rules: [
              {
                required: true,
                message: 'Please enter user\'s Last Name.'
              },
              {
                whitespace: true,
                message: 'Please enter user\'s First Name.'
              }
            ]
          })(<Input placeholder="Bloggs" disabled={readonly} />)}
        </FormItem>
      </Form>
    </>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  checkboxFormItemLayout: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  dataSource: {},
  form: {},
  checkboxFormItemLayout: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const AccountInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default AccountInput;
